<template>
  <nav
    class="navbar navbar-expand-lg inner-header d-flex justify-content-between px-3 py-2 "
  >
    <a class="navbar-brand brand-logo">
      <img :src="logo" alt="">
    </a>
    <div v-if="showDemoMsg" class="text-center text-primary w-100">
      This site is intended for demonstration purposes only.
    </div>
    <div class="" id="navbarSupportedContent">
      <ul class="d-flex gap-3 align-items-center mb-0 p-0">
        <label class="switch" v-if="darkModePresent">
            <input type="checkbox" @change="toggleTheme()" :checked="isDarkMode">
            <span class="sliderToggle"></span>
        </label>
        <router-link to="/" class="text-center" v-if="isHomeVisible">
         <img src="../../assets/images/homeicon.svg" class="homeicons"  />
          
          <p class="headerpara">Home</p>
              </router-link>
              <router-link to="/dashboard" class="text-center" v-if="isDashboardVisible && this.rmData?.RoleId != '1'">
                <img src="/images/dashboard.png" alt="" width="20px" class="homeicons">
                 <p class="headerpara">Dashboard</p>
              </router-link>
              <ProfileDropdown @logOutUser="logout" v-if="isUserVisible && this.rmData?.RoleId != '1'"/>
      </ul>
    </div>
    <div v-if="tokenWarningFlag" id="tokenWarningAlert" class="custom-warning-alert modal fade show">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered premium-modal">
        <div class="modal-content">
          <div class="">
            <div class="icon-box">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            </div>
            <h5 class="modal-title text-center pt-4 px-5">Session Expiry Warning!</h5>
            <!-- <button type="button" @click="closeAlertDialog()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          </div>
          <div class="modal-body">
            <p><span class="p-2">Your session is about expire. Please click Ok to continue</span></p>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="next-btn btn mb-4" @click="tokenCancel()" style="width:100px" >Cancel</button>
            <button type="button" class="next-btn clickbuttons mb-4" @click="tokenContinue()" style="width:100px" >Ok</button>
          </div>  
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { getDistributer, hasDarkMode } from '@/mixins/common';
import { Buffer } from "buffer";
// import axios from "axios";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import ProfileDropdown from './profileDropdown.vue';
export default {
  name: "innerHeader",
  components: {
    ProfileDropdown
  },
  async mounted() {
    this.theme = this.$store.state.theme;
    this.logo= this.$store.state.theme =='light' ? getDistributer()["distributorLogo"] : getDistributer()["distributorLogoDark"];
    await this.handleDeeplinks();
    if (window.location.hostname.includes("insurance.1silverbullet.tech")) {
      this.showDemoMsg = true;
    } else {
      this.showDemoMsg = false;
    }
    let diy = this.$route.query.diy ? this.$route.query.diy : false;
    if (sessionStorage.getItem("diy") == null) {
      sessionStorage.setItem("diy", diy);
    }
    if (this.$store.state.token && this.$route.query.id) {
      let rm_id = this.$route.query;
      if (rm_id) {
        await this.startSession(rm_id);
      }
    } else if (this.$store.state.token && sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
      if (JSON.parse(sessionStorage.getItem("sessionExpiryTime")) == true) {
        this.tokenWarning();
      }
      if(this.rmId && (this.rmId!=this.rmData["transaction_id"])){
        sessionStorage.clear();
        await this.startSession(this.rmId)
      }
    } else if(this.$route.query.token){
      try {
        const token = this.$route.query.token;
        this.decodeToken = jwt_decode(this.$route.query.token);
        const journey_id = this.decodeToken.PAYLOAD.journey_id;
        const transId = this.decodeToken.PAYLOAD.transactionId;
        if(this.decodeToken.PAYLOAD.externalReferenceId == "" && this.decodeToken.PAYLOAD.userid == ""){
          let msg=['Token is Invalid']
          this.$router.push({ path: '/errorhandle', query: {backUrl:'savingsGateCriteria', msg: msg}});
        }
        sessionStorage.setItem("journey_id", journey_id);
        this.$store.commit("setJourneyId", journey_id);
        this.$store.commit("setToken", this.$route.query.token);
        await this.fetchRmDetails(token);
      }
      catch (err) {
        console.log('token is null: ', err);
      }
    } else if (!this.$store.state.token) {
      let rm_id = this.$route.query;
      if (rm_id) {
        await this.startSession(rm_id);
      }
    }
    this.distributorLogo = getDistributer()["distributorLogo"];
    const isPreFilled = getDistributer()['isPreFilled'];
    if (isPreFilled && this.$store.state.token) {
      if (!this.$store.state.customerData) {
        await this.getCustomerDetails();
      }
    }
    this.darkModePresent = hasDarkMode();
  },
  unmounted() {
    clearInterval(this.intervalTime); // - Clears Interval
  },
  data() {
    return {
      darkModePresent: false,
      decodeToken:"",
      multiQuote:false,
      rmData: "",
      loading: false,
      tokenExpireWarning: false,
      tokenExpireWarningCancel: false,
      intervalTime: null,
      logo:'',
      tokenWarningFlag: false,
      deepLinkParams:{
        productId: undefined,
        manufacturerId : undefined,
        quoteAmount: undefined,
        premiumPaymentTerm: undefined,
        premiumPaymentFrequency: undefined,
        policyTerm: undefined
      },
      showDemoMsg:false
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    isDarkMode() {
      return this.theme === 'light';
    },
    isHomeVisible() {
      const configData = this.$store.state.configData;
      const rmDataStr = sessionStorage.getItem("rm_data");
      let rmData = null;
      try {
        if (rmDataStr) {
          rmData = JSON.parse(rmDataStr);
        }
      } catch (error) {
        console.error("Error parsing rm_data:", error);
      }
      const roleId = rmData && typeof rmData === 'object' ? String(rmData.RoleId) : null;
      
      const uiConfig = configData?.UI_CONFIG;
      
      if (uiConfig?.ROLE_ID && roleId && uiConfig.ROLE_ID[roleId] && typeof uiConfig.ROLE_ID[roleId].home === 'boolean') {
        return uiConfig.ROLE_ID[roleId].home;
      }
      // Default to true if data not available
      return true;
    },
    isDashboardVisible() {
      const configData = this.$store.state.configData;
      const rmDataStr = sessionStorage.getItem("rm_data");
      let rmData = null;
      try {
        if (rmDataStr) {
          rmData = JSON.parse(rmDataStr);
        }
      } catch (error) {
        console.error("Error parsing rm_data:", error);
      }
      const roleId = rmData && typeof rmData === 'object' ? String(rmData.RoleId) : null;
      
      // Hardcode: Role ID 1 should not have dashboard access
      if (roleId === '1') {
        return false;
      }
      
      const uiConfig = configData?.UI_CONFIG;
      
      if (uiConfig?.ROLE_ID && roleId && uiConfig.ROLE_ID[roleId] && typeof uiConfig.ROLE_ID[roleId].dashboard === 'boolean') {
        return uiConfig.ROLE_ID[roleId].dashboard;
      }
      // Default to true if data not available
      return true;
    },
    isUserVisible() {
      const configData = this.$store.state.configData;
      const rmDataStr = sessionStorage.getItem("rm_data");
      let rmData = null;
      try {
        if (rmDataStr) {
          rmData = JSON.parse(rmDataStr);
        }
      } catch (error) {
        console.error("Error parsing rm_data:", error);
      }
      const roleId = rmData && typeof rmData === 'object' ? String(rmData.RoleId) : null;
      
      const uiConfig = configData?.UI_CONFIG;
      
      if (uiConfig?.ROLE_ID && roleId && uiConfig.ROLE_ID[roleId] && typeof uiConfig.ROLE_ID[roleId].userDropdown === 'boolean') {
        return uiConfig.ROLE_ID[roleId].userDropdown;
      }
      // Default to true if data not available
      return true;
    },
  },
  methods:{
    toggleTheme(){
      this.$store.dispatch('toggleTheme');
    },
    tokenCancel(){
      this.tokenExpireWarningCancel = true;
      this.tokenWarningFlag = false;
    },
    tokenContinue(){
      this.tokenExpireWarning = true
      this.tokenWarningFlag = false;
    },
    async startSession(rm_id) {
      try {
        let data = {};

        if (rm_id?.journeyId != null) {
          this.rmId = rm_id;
          sessionStorage.clear();
          sessionStorage.setItem("journeyId", this.rmId.journeyId);
          this.$store.commit("setJourneyId", this.rmId.journeyId);
          data = {
            journey_id: this.rmId.journeyId,
          };
        } else {
          this.rmId = rm_id;
          data = {
            transactionId: this.rmId.id,
          };
        }

        const url = this.$route.query.override ? "generateTokenOverride" : "generateToken";

        const resp = await this.backendApi(url, data);
        console.log(resp.data);

        if (resp.data.errors.length > 0) {
          return this.$router.push({
            path: "/error-page",
            query: { msg: resp.data.errors[0]["errorMessage"] },
          });
        }

        const token = resp.data.data.token.access_token;

        if (getDistributer()["isPreFilled"]) {
          this.decodeToken = jwt_decode(token);
          this.$store.commit("setCustomerId", this.decodeToken.PAYLOAD.externalReferenceId);
        }

        console.log(token, "fetchRmDetails token");
        await this.fetchRmDetails(token);
      } catch (error) {
        console.error("Failed to start session", error);
        this.$router.push({
          path: "/error-page",
          query: { msg: error.message || "Something went wrong" },
        });
      }
    },
    async fetchRmDetails(token) {
      try {
        const response = await this.backendApi("getRmDetails", [], { Authorization: `Bearer ${token}` }, "get");

        if (response.data.errors.length > 0) {
          return this.$router.push({
            path: "/error-page",
            query: { msg: response.data.errors[0]["errorMessage"] },
          });
        }

        //if (response && response.data) {
        this.rmData = response.data.data;

        // if (this.rmData) {
        sessionStorage.setItem("rm_data", JSON.stringify(this.rmData));
        sessionStorage.setItem("sessionExpiryTime", "true");

        if (this.rmData["RoleId"] === "1") {
          sessionStorage.setItem("diy", "true");
        }
        // }
        //}

        if (!this.rmData) {
          this.$store.commit("setToken", null);
        } else {
          this.$store.commit("setToken", token);
          this.$store.commit("setRmId", "");
          this.$emit("clicked-rm-details", this.rmData);
          if (!this.$store.state.configData && this.$store.state.token) {
            await this.getConfigData();
          }
        }
      } catch (error) {
        console.error("Error fetching RM details:", error);
        this.$router.push({
          path: "/error-page",
          query: { msg: error.message || "Something went wrong" },
        });
      }
    },
    logout(isLogout = true) {
      if (!isLogout) {
        this.handleHomepage();
      } else {
        const logOutUrl = this.rmData && this.rmData.LogOutUrl;
        sessionStorage.clear();
        localStorage.clear();
        if (sessionStorage.getItem("rm_data")) {
          this.rmData = JSON.parse(sessionStorage.getItem("rm_data"))
        }
        else{
          this.rmData = "";
        }
        if (logOutUrl && logOutUrl !== null) {
          window.location.href = logOutUrl;
        } else {
          if (this.rmData['RoleId'] == '1') {
            window.location.href = process.env.VUE_APP_LOGOUT_URL_B2C;
          }
          else {
            window.location.href = process.env.VUE_APP_LOGOUT_URL_B2B;
          }
        }
      }
    },
    async getConfigData() {
      try {
        const headers = {
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
          "Content-Type": "application/json",
        };

        const reqData = [getDistributer()["distributerID"]];

        const response = await this.backendApi("getConfigData", reqData, headers, "get");
        if (!response || response === "error" || response.data.errors && response.data.errors.length > 0) {
          console.error("get config data error: block");
          this.$router.push({
            path: "/error-page",
            query: { msg: response.data.errors[0]["errorDisplayMessage"] },
          });
          return;
        }

        if (response.data && response.data.data?.Jsondata?.[0]?.jsonDataUI) {
          this.$store.commit("setConfigData", response.data.data.Jsondata[0].jsonDataUI);
          setTimeout(() => {
            location.href = location.origin;
          }, 1200);
        }
      } catch (error) {
        console.error("Error fetching config data:", error);
      }
    },
    handleHomepage() {
      window.location.href = window.location.origin + "/#/";
    },
    tokenWarning() {
    let self = this;
    this.intervalTime = setInterval( function(){
      let decodedToken = self.parseJwt(self.$store.state.token)
      // console.log("kjsdbnbv",((decodedToken['expires'] - Date.now() / 1000) / 60));
      let timer = ((decodedToken['expires'] - Date.now() / 1000) / 60);
      if (timer <= 1 && timer > 0) {
        // token getting expired (have to refresh)
        this.tokenWarningFlag = true;
        setTimeout(() => {
          document.querySelector("#tokenWarningAlert").style.display = 'block'
        }, 100);
        // $("#tokenWarningModal").modal("show");
        if(self.tokenExpireWarningCancel == true){
          sessionStorage.setItem("sessionExpiryTime",'false');
          clearInterval(self.intervalTime);
          this.tokenWarningFlag = false;
          setTimeout(() => {
            document.querySelector("#tokenWarningAlert").style.display = 'none'
          }, 100);
          // $("#tokenWarningModal").modal("hide");
        }
        if(self.tokenExpireWarning == true){
          this.tokenWarningFlag = false;
          setTimeout(() => {
            document.querySelector("#tokenWarningAlert").style.display = 'none'
          }, 100);
          // $("#tokenWarningModal").modal("hide");
          let data = {
            currentToken: self.$store.state.token
          }
          self.backendApi("refreshToken", data)
          .then((resp) => {
            if(resp.data.errors.length>0){
              self.$router.push({ path: '/error-page', query: {msg:"Unable to refresh token"}});
            }
            self.tokenExpireWarning = false;
            let token = resp.data.data.newToken.access_token;
            self.$store.commit('setToken',token);
            self.callTokenWarning();
          })
          .catch((error) => {
            console.log("Failed to start session",error);
            let msg= "Failed to start session"
            self.$router.push({ path: '/error-page', query: {msg: msg }});
          })
        }
      }
      else if(timer <= 0){
        sessionStorage.setItem("sessionExpiryTime",'false');
        clearInterval(self.intervalTime);
        //  $("#tokenWarningModal").modal("hide");
        this.tokenWarningFlag = false;
        setTimeout(() => {
          document.querySelector("#tokenWarningAlert").style.display = 'none'
        }, 100);
        sessionStorage.removeItem('vuex')
        window.location.href = `${window.location.origin}/#/networkalert?msg=Your session time is expired , kindly login again&backUrl=logout`
        // window.history.replaceState("", "", `${window.location.origin}/#/networkalert?msg=Your session time is expired , kindly login again&backUrl=logout`);
        // window.location.reload();
      }
    },1000);
  },
  callTokenWarning(){
    clearInterval(this.intervalTime);
    this.tokenWarning();
  },
  parseJwt(token) {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
   },
    async getCustomerDetails() {
      try {
        const customerId = this.$store.state.customerId || "CUST00011060";
        const body = {
          customerHashId: customerId,
          pan: "",
          firstName: "",
          lastName: "",
          dob: "",
        };

        const response = await this.backendApi("getCustomerDetails", body, {});

        if (!response || !response.data || !response.data.data) {
          throw new Error("Invalid response received from API");
        }

        const customerData = response.data.data.customer_info;
        this.$store.commit("setCustomerData", customerData);
        console.log("Customer details fetched successfully", customerData);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    },
    handleDeeplinks() {
      if (this.$route.query.id) {
        const {
          motorProductType,
          mobile,
          email,
          registrationNo
        } = this.$route.query;
        const updatedParams = {};
        if (motorProductType !== undefined) {
          updatedParams.motorProductType = motorProductType;
        }
        if (mobile !== undefined) {
          updatedParams.mobile = mobile;
        }
        if (email !== undefined) {
          updatedParams.email = email;
        }
        if (registrationNo !== undefined) {
          updatedParams.registrationNo = registrationNo;
        }
        if (Object.keys(updatedParams).length > 0) {
          this.$store.commit("setDeepLinkParams", {
            ...this.$store.state.deepLinkParams,
            ...updatedParams
          });
        }
      }
    },
  },
  watch: {
    theme(newTheme) {
      if (newTheme) {
        this.logo= newTheme =='dark' ? getDistributer()["distributorLogoDark"] : getDistributer()["distributorLogo"];
        document.body.className = newTheme;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/inner-header.scss";
</style>
